/**
 * Utility functions for estate waterfall edge label cards
 */

/**
 * Gets the display string for trust term duration, checking lifetime flag first
 */
export function getTrustTermDisplay({
  termDurationLifetime,
  termDurationYears,
}: {
  termDurationLifetime?: boolean;
  termDurationYears?: number | null;
}): string | null {
  if (termDurationLifetime) {
    return 'Lifetime';
  }

  if (termDurationYears) {
    return `${termDurationYears} years`;
  }

  return null;
}
